const FADE_DELAY = 13000;
const FADE_DURATION = 11000;
export const MSG_LIFETIME = FADE_DELAY + FADE_DURATION + 800;

export function energy(lastActivity: number | null, now: number): number {
  if (!lastActivity) return 0.05;
  const elapsed = now - lastActivity;
  if (elapsed < 500) return 1;
  const t = Math.min(1, (elapsed - 500) / 20000);
  return Math.max(0.05, 1 - t * t);
}

export function msgOpacity(submittedAt: number, now: number): number {
  const elapsed = now - submittedAt;
  if (elapsed < FADE_DELAY) return 1;
  const t = Math.min(1, (elapsed - FADE_DELAY) / FADE_DURATION);
  return Math.max(0, 1 - t * t * t);
}

export function hexAlpha(color: string, alpha: number): string {
  const a = Math.round(Math.max(0, Math.min(255, alpha)));
  return color + a.toString(16).padStart(2, '0');
}
